
const adobeAnalytics =
    document.documentElement.lang === "ja" ? (() => {
        if (typeof digitalData === 'undefined') {
            window.digitalData = {};
            digitalData = window.digitalData;
        }

        const _trackEvent = (eventName, eventData) => {
            if (typeof digitalData !== 'undefined') {
                switch (eventName) {
                    case "eventTracking":
                        digitalData.component = eventData;
                        _satellite?.track(eventName);
                         break;
                    case "pageLoad":
                    case "registrationSuccess":
                        digitalData.page = eventData.page;
                        digitalData.User = eventData.user;
                        _satellite?.track(eventName);
                        break;
                    case "errorTracking":
                        digitalData.error = eventData;
                        _satellite?.track(eventName);
                          break;
                    default:
                }
            }
        };

        const _trackNavigationLink = (event) => {
            const trackingObj = {
                componentType: "link",
                componentName: "",
                buttonName: event.currentTarget.innerText ? event.currentTarget.innerText : null,
                blockName: "navigation",
                componentPosition: "",
                isCampaign: "",
                campaignName: "",
                urlType: event.currentTarget.getAttribute('data-cta-type') ? event.currentTarget.getAttribute('data-cta-type') : null,
                clickURL: event.currentTarget.getAttribute('href') ? window.location.href+event.currentTarget.getAttribute('data-parameters') : null,
            };

            _trackEvent("eventTracking", trackingObj);
        };

        const _trackFooterLink = (event, componentDetail) => {
            const trackingObj = {
                componentType: "footer",
                componentName: "",
                buttonName: event.currentTarget.innerText ? event.currentTarget.innerText.replace(/\n/g, " ") : null,
                blockName: componentDetail.blockName,
                componentPosition: "",
                isCampaign: "",
                campaignName: "",
                urlType: event.currentTarget.getAttribute('data-cta-type') ? event.currentTarget.getAttribute('data-cta-type') : null,
                clickURL: event.currentTarget.getAttribute('data-parameters')?window.location.href+event.currentTarget.getAttribute('data-parameters'):window.location.href+"/"+componentDetail.destination,
            };

            _trackEvent("eventTracking", trackingObj);
        };

        const _trackNewsletterBtn = (event, componentDetail) => {
                const eventData = {
                componentType: "button",
                componentName: "",
                buttonName: event.length?event[0].querySelector("span").innerText:"",
                blockName: componentDetail.blockName,              
                componentPosition: "",
                isCampaign: "",
                campaignName: "",
                urlType: event.length?event[0].getAttribute("data-cta-type") ? event[0].getAttribute('data-cta-type') : "internal":"",
                clickURL: "",
            };

            _trackEvent("eventTracking", eventData);

        };

        const _trackCloseIcon = (event, componentDetail) => {
                const eventData = {
                componentType: "button",
                componentName: "",
                buttonName: "close",
                blockName: componentDetail.blockName,
                componentPosition: "",
                isCampaign: "",
                campaignName: "",
                urlType: event.length?event[0].getAttribute("data-cta-type") ? event[0].getAttribute('data-cta-type') : "internal":"",
                clickURL: "",
            };

            _trackEvent("eventTracking", eventData);

        };

        const _trackPage = (page, componentDetail) => {
            const eventData = {
                page: {
                    pageName: "jp:vuse:" + componentDetail.destination,
                    URL: page.currentTarget.getAttribute('data-parameters')?window.location.href+page.currentTarget.getAttribute('data-parameters'):window.location.href+"/"+componentDetail.destination,
                    pageType: page.currentTarget.getAttribute('data-cta-type') ? page.currentTarget.getAttribute('data-cta-type') : null,
                    siteSection: "jp:vuse:" + componentDetail.destination,
                    campaignName: "",
                },
                user: {
                    loginstatus: Utils.getCookie('commerce-auth-verify') === 'true' ? true : false,
                }
            };
            _trackEvent("pageLoad", eventData);
        };

        const _trackButton = (event, componentDetail) => {
            const eventData = {
                componentType: "button",
                componentName: "",
                buttonName: event.currentTarget.innerText ? event.currentTarget.innerText : null,
                blockName: componentDetail.blockName,
                componentPosition: "",
                isCampaign: "",
                campaignName: "",
                urlType: event.currentTarget.getAttribute('data-cta-type') ? event.currentTarget.getAttribute('data-cta-type') : event.currentTarget.getAttribute('data-link-type') ? event.currentTarget.getAttribute('data-link-type'):null,
                clickURL: event.currentTarget.getAttribute("href") ? event.currentTarget.getAttribute("href") : event.currentTarget.getAttribute('data-url') ? event.currentTarget.getAttribute('data-url') : null,
            };

            _trackEvent("eventTracking", eventData);
        };

        const _trackStoreCTA = (event, componentDetail) => {
            const eventData = {
                componentType: "button",
                componentName: "",
                buttonName: event.currentTarget.innerText ? event.currentTarget.innerText+":"+componentDetail.storePos+":"+componentDetail.storeName : null,
                blockName: componentDetail.blockName,
                componentPosition: "",
                isCampaign: "",
                campaignName: "",
                urlType: event.currentTarget.getAttribute('data-cta-type') ? event.currentTarget.getAttribute('data-cta-type') : event.currentTarget.getAttribute('data-link-type') ? event.currentTarget.getAttribute('data-link-type'):null,
                clickURL: event.currentTarget.getAttribute("href") ? event.currentTarget.getAttribute("href") : event.currentTarget.getAttribute('data-url') ? event.currentTarget.getAttribute('data-url') : null,
            };

            _trackEvent("eventTracking", eventData);
        };

        const _trackStoreImages = (event, componentDetail) => {
            const eventData = {
                componentType: "Image",
                componentName: "",
                ImageName: "Store Image"+":"+componentDetail.storePos+":"+componentDetail.storeName,
                blockName: componentDetail.blockName,
                componentPosition: "",
                isCampaign: "",
                campaignName: "",
                urlType: event.currentTarget.getAttribute('data-cta-type') ? event.currentTarget.getAttribute('data-cta-type') : event.currentTarget.getAttribute('data-link-type') ? event.currentTarget.getAttribute('data-link-type'):null,
                clickURL: event.currentTarget.getAttribute("href") ? event.currentTarget.getAttribute("href") : event.currentTarget.getAttribute('data-url') ? event.currentTarget.getAttribute('data-url') : null,
            };

            _trackEvent("eventTracking", eventData);
            
        };

        const _trackSliderButton = (event, componentDetail) => {
            const eventData = {
                componentType: componentDetail.blockName + " slider",
                componentName: componentDetail.blockName,
                buttonName: "",
                componentPosition: event.currentTarget.innerText ? event.currentTarget.innerText : null,
                blockName: componentDetail.blockName,
                componentPosition: "",
                isCampaign: "",
                campaignName: "",
                urlType: "",
                clickURL: "",
            };

            _trackEvent("eventTracking", eventData);
        };

        const _trackFAQButton = (event, componentDetail) => {
            const question = event.currentTarget.querySelector('.bat-expander-button-label').innerText;
            const eventData = {
                componentType: componentDetail.sectionName,
                componentName: componentDetail.sectionName + "-" + question,
                buttonName: componentDetail.sectionName,
                blockName: componentDetail.blockName,
                componentPosition: "",
                isCampaign: "",
                campaignName: "",
                urlType: "internal",
                clickURL: "",
            };
            _trackEvent("eventTracking", eventData);
        };

        return {
            trackEvent: _trackEvent,
            trackNavigationLink: _trackNavigationLink,
            trackNewsletterBtn: _trackNewsletterBtn,
            trackPage: _trackPage,
            trackButton: _trackButton,
            trackFAQButton: _trackFAQButton,
            trackSliderButton: _trackSliderButton,
            trackFooterLink: _trackFooterLink,
            trackCloseIcon: _trackCloseIcon,
            trackStoreCTA: _trackStoreCTA,
            trackStoreImages: _trackStoreImages
        };
    })() : "";
